import React from "react"

import Layout from "../components/layout"
import Snippet from "../components/snippet"

const Retro = () => (
	<Layout
		meta={{
			title: "Retrospective on Accento 2019",
			description:
				"Looking back on Accneto 2019, which took place in Karlsruhe, Germany, on Sep 24th/25th 2019.",
			path: "/retro",
		}}
	>
		<Snippet id="retro" />
	</Layout>
)

export default Retro
